import color from './color';
import { getSizes } from './size';

const { border: borderColor } = color;

const border = {
  small: `1px solid ${borderColor.primary.default()}`,
  invertedSmall: `1px solid ${borderColor.reversed.default()}`,
  double: `2px solid ${borderColor.primary.default()}`,
  dashedGrouped: `1px dashed ${borderColor.secondary.default()}`,
  dashedDouble: `2px dashed ${borderColor.primary.default()}`,
  dashedDoubleInverted: `2px dashed ${borderColor.reversed.default()}`,
  dashedDoubleSelected: `2px dashed ${borderColor.accent.default()}`,
};

const multiBorder = {
  basic: {
    border: `1px solid ${borderColor.primary.default()}`,
    borderOnHover: `1px solid ${borderColor.primary.hover()}`,
    borderOnFocus: `1px solid ${borderColor.accent.default()}`,
    borderOnSelected: `1px solid ${borderColor.accent.default()}`,
  },
  disabled: {
    border: `1px solid ${borderColor.secondary.default()}`,
    borderOnHover: `1px solid ${borderColor.secondary.default()}`,
    borderOnFocus: `1px solid ${borderColor.accent.default()}`,
    borderOnSelected: `1px solid ${borderColor.accent.default()}`,
  },
  double: {
    border: `2px solid ${borderColor.primary.default()}`,
    borderOnHover: `2px solid ${borderColor.primary.hover()}`,
    borderOnFocus: `2px solid ${borderColor.primary.default()}`,
    borderOnSelected: `2px solid ${borderColor.accent.default()}`,
  },
  dashed: {
    border: `2px dashed ${borderColor.primary.default()}`,
    borderOnHover: `2px dashed ${borderColor.primary.hover()}`,
    borderOnFocus: `2px dashed ${borderColor.primary.default()}`,
    borderOnSelected: border.dashedDoubleSelected,
  },
  error: {
    border: `1px solid ${borderColor.error.default()}`,
    borderOnHover: `1px solid ${borderColor.error.default()}`,
    borderOnFocus: `1px solid ${borderColor.error.default()}`,
    borderOnSelected: `1px solid ${borderColor.error.default()}`,
  },
  success: {
    border: `1px solid ${borderColor.primary.default()}`,
    borderOnHover: `1px solid ${borderColor.primary.default()}`,
    borderOnFocus: `1px solid ${borderColor.primary.default()}`,
    borderOnSelected: `1px solid ${borderColor.primary.default()}`,
  },
};

const getBorderRadius = (inPixels = false) => {
  const size = getSizes(inPixels);

  return {
    large: `${size.double}`,
    medium: `${size.unit}`,
    small: `${size.half}`,
  };
};

export { getBorderRadius, border, multiBorder };
